import { render } from "./statistics.vue?vue&type=template&id=19737002&ts=true"
import script from "./statistics.vue?vue&type=script&lang=ts&config=true"
export * from "./statistics.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__